import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useRef } from "react";
import { Toast } from "primereact/toast";
export const ToastContext = createContext(null);
const DURATION_MAP = {
    'short': 3000,
    'medium': 5000,
    'long': 15000 // 15 seconds
};
const ToastContextProvider = ({ children }) => {
    const toastRef = useRef(null);
    const showToast = useCallback((data) => {
        var _a, _b;
        (_a = toastRef.current) === null || _a === void 0 ? void 0 : _a.show((Object.assign({ life: (_b = DURATION_MAP[data.duration]) !== null && _b !== void 0 ? _b : DURATION_MAP.medium }, data)));
    }, []);
    const clearToast = useCallback(() => {
        var _a;
        (_a = toastRef.current) === null || _a === void 0 ? void 0 : _a.clear();
    }, []);
    return (_jsxs(ToastContext.Provider, Object.assign({ value: {
            showToast,
            clearToast
        } }, { children: [_jsx(Toast, { style: {
                    fontFamily: "var(--fnt-veeva)",
                    fontSize: "calc(var(--fnt-size) * 0.9)"
                }, ref: toastRef }), children] })));
};
export const useToastContext = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToastContext must be used within a ToastContextProvider.");
    }
    return context;
};
export default ToastContextProvider;
